import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_UPDATE_ASSOCIATION_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_UPDATE_ASSOCIATION_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/UpdateAssociationModal')
};